import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import {Chart,registerables} from 'chart.js';

@Component({
  selector: 'sm-stacked-bar-chart',
  templateUrl: './stacked-bar-chart.component.html',
  styleUrls: ['./stacked-bar-chart.component.scss']
})
export class StackedBarChartComponent implements OnInit {
  public chart: any;
  canvas: any;
  ctx: any;
  @Input() dataSource: {
    labels: string[],
    datasets: {
      label: string,
      data: number[],
      backgroundColor?: string | string[],
      borderColor?: string | string[],
      borderWidth?: number
    }[]
  } = { labels: [], datasets: [] };
  // @ViewChild('mychart') mychart:any;
  @ViewChild('mychart', {static: false}) mychart!: ElementRef;
  constructor() { }

  ngOnInit(): void {
    // this.createChart();
  }


ngAfterViewInit() {
setTimeout(() => {
  Chart.register(...registerables);
  this.canvas = this.mychart.nativeElement;

this.ctx = this.canvas.getContext('2d');
console.log(this.dataSource);

new Chart(this.ctx, {
    type: 'bar',
    data: this.dataSource,
    options: {
      plugins:{
        legend: {
        display: true,
        position: 'bottom'
      },

      },
      scales: {
        x: {
          stacked: true
        },
        y: {
          stacked: true
        }
      }
      // scales: {
      //     yAxes: [{
      //         ticks: {
      //             beginAtZero: true
      //         }
      //     }]
      // }
  }
});


}, 100);

}

}